import React, {useState} from 'react';

import RuleScoreGrid from './RuleScoreGrid';
import ScoreGraph from './ScoreGraph';
import ScoreGrid from './ScoreGrid';
import SensorGraph from './SensorGraph';

import EquipmentScoreGrid from '../../../../components/ScoringGrids/EquipmentScoreGrid';
import RulesScoreGrid from '../../../../components/ScoringGrids/RulesScoreGrid';

import * as classes from './ScoringGridContainer.module.css';
import RawDataTable from '../../../../components/RawDataTable/RawDataTable';


const initialDataStateFilter = {
    logic:   'and',
    filters: []
};

const initialRawDataState = {
    filter: initialDataStateFilter,
    sort:   [],
    group:  [],
    skip:   0
};

const ScoringGridContainer = ({
    aggregateType,
    chartType,
    exportRawData,
    healthscoreRawData,
    healthscoreRawDataMeta,
    refreshRawDataGrid,
    rules,
    selectedEquipment,
    selectedEquipmentTypes,
    selectedSystems,
    setRefreshRawDataGrid,
    setSelectedEquipment,
    selectedEquipmentRule,
    setExportRawData,
    setRules,
    refresh,
    setSelectedEquipmentRule,
    site,
    view,
    ...props
}) => {
    const [rawDataGridDataState, setRawDataGridDataState] = useState(initialRawDataState);
    const [rawGridFilterText, setRawGridFilterText] = useState('');
    const [rawGridFilter, setRawGridFilter] = useState(initialDataStateFilter);
    const [rawGridFields, setRawGridFields] = useState([]);

    return (
        <div className={classes.ScoringGridContainer}>
            <div className={classes.EquipmentScoreGridContainer}>
                <EquipmentScoreGrid
                    refreshEquipmentGrid={refreshRawDataGrid}
                    selectedEquipment={selectedEquipment}
                    selectedEquipmentTypes={selectedEquipmentTypes}
                    selectedEquipmentRule={selectedEquipmentRule}
                    selectedSystems={selectedSystems}
                    setSelectedEquipment={setSelectedEquipment}
                    setSelectedEquipmentRule={setSelectedEquipmentRule}
                    view={view}
                />
            </div>
            <div className={classes.RuleScoreGrid}>
                { view === 'rawdata' ? 
                    <RulesScoreGrid
                        selectedEquipment={selectedEquipment}
                        setSelectedEquipmentRule={setSelectedEquipmentRule}
                        setRules={setRules}
                        selectedEquipmentRule={selectedEquipmentRule}
                        refreshRuleGrid={refreshRawDataGrid}
                        rules={rules}
                    />
                    : 
                    <RuleScoreGrid
                        selectedEquipment={selectedEquipment}
                        setSelectedEquipmentRule={setSelectedEquipmentRule}
                        setRules={setRules}
                        selectedEquipmentRule={selectedEquipmentRule}
                        rules={rules}
                    />
                }
            </div>
            <div className={classes.ScoreGrid}>
                {
                    view === 'scoregrid' ?
                        <ScoreGrid
                            aggregateType={aggregateType}
                            selectedEquipmentRule={selectedEquipmentRule}
                            refresh={refresh}
                        />
                        : view === 'rawdata' ?
                            <RawDataTable 
                                activeEquipment={selectedEquipment}
                                activeSite={site}
                                exportRawData={exportRawData}
                                gridDataState={rawDataGridDataState}
                                gridFields={rawGridFields}
                                gridFilterText={rawGridFilterText}
                                gridFilter={rawGridFilter}
                                healthscoreRawData={healthscoreRawData}
                                healthscoreRawDataMeta={healthscoreRawDataMeta}
                                isSiteView={true}
                                refreshRawDataGrid={refreshRawDataGrid}
                                selectedEquipmentRule={selectedEquipmentRule}
                                setGridDataState={setRawDataGridDataState}
                                setExportRawData={setExportRawData}
                                setGridFilterText={setRawGridFilterText}
                                setGridFilter={setRawGridFilter}
                                setGridFields={setRawGridFields}
                                setRefreshRawDataGrid={setRefreshRawDataGrid}
                                setSelectedEquipmentRule={setSelectedEquipmentRule}
                            />
                            :
                            chartType === 'Rules' ?
                                <ScoreGraph
                                    selectedEquipment={selectedEquipment}
                                    selectedEquipmentRule={selectedEquipmentRule}
                                    propsFunc={props.propsFunc}
                                    isActive={view === 'scoregraph'}
                                />
                                :
                                <SensorGraph
                                    selectedEquipment={selectedEquipment}
                                    selectedEquipmentRule={selectedEquipmentRule}
                                    propsFunc={props.propsFunc}
                                    isActive={view === 'scoregraph'}
                                />

                }
            </div>
        </div>
    );
};

export default ScoringGridContainer;
